export type TCognitoRole =
  | 'platformadmin'
  | 'companyadmin'
  | 'agencyadmin'
  | 'mainagencyadmin'
  | 'agencyuser'
  | 'ollicandidate'
  | 'general_admin'

export type TDisplayedRole =
  | 'Platform Administrator'
  | 'Company Administrator'
  | 'Agency Administrator'
  | 'Main Agency Administrator'
  | 'Agency User'
  | 'Olli Candidate'
  | 'General Administrator'

export type TOperation = 'Create' | 'Read' | 'Update' | 'Delete' | 'UpdateStatus'

export function displayToCognito(arg: unknown): TCognitoRole {
  switch (arg) {
    case 'Platform Administrator':
      return 'platformadmin'
    case 'Company Administrator':
      return 'companyadmin'
    case 'Agency Administrator':
      return 'agencyadmin'
    case 'Main Agency Administrator':
      return 'mainagencyadmin'
    case 'Agency User':
      return 'agencyadmin'
    case 'Olli Candidate':
      return 'ollicandidate'
    case 'General Administrator':
      return 'general_admin'
    default:
      throw Error(`Could not transform [${arg}] into a Cognito role.`)
  }
}

export function cognitoToDisplay(arg: unknown): TDisplayedRole | string {
  switch (arg) {
    case 'platformadmin':
      return 'Platform Administrator'
    case 'companyadmin':
      return 'Company Administrator'
    case 'agencyadmin':
      return 'Agency Administrator'
    case 'mainagencyadmin':
      return 'Main Agency Administrator'
    case 'agencyuser':
      return 'Agency Administrator'
    case 'ollicandidate':
      return 'Olli Candidate'
    case 'general_admin':
      return 'General Administrator'
    default:
      // For custom roles, return the role name exactly as entered by user
      if (typeof arg === 'string') {
        return arg
      }
      return String(arg)
  }
}

export interface IAccessItem {
  entityType: string
  operations: TOperation[]
  scope: string
}

export interface IRole {
  id: string
  name: TCognitoRole
  accessList: IAccessItem[]
}
